var _rect, _rect2, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21836_63200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21836_63200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0508 42.7233L41.6673 39.0378V32.5H38.334V40.9623L46.3842 45.61L48.0508 42.7233Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0007 56.6654C49.2053 56.6654 56.6673 49.2034 56.6673 39.9987C56.6673 30.7939 49.2053 23.332 40.0007 23.332C30.7959 23.332 23.334 30.7939 23.334 39.9987C23.334 49.2034 30.7959 56.6654 40.0007 56.6654ZM40.0007 53.332C47.3645 53.332 53.334 47.3625 53.334 39.9987C53.334 32.6349 47.3645 26.6654 40.0007 26.6654C32.6369 26.6654 26.6673 32.6349 26.6673 39.9987C26.6673 47.3625 32.6369 53.332 40.0007 53.332Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21836_63200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21836_63200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockInCircle);
export default __webpack_public_path__ + "static/media/clockInCircle.b6acd0f634ea13140724f6c5540ef606.svg";
export { ForwardRef as ReactComponent };